const CredencialsModal = ({ setModalOpen, credentials }) => {
    const handleCopyClientId = () => {
        navigator.clipboard.writeText(credentials.clientId);
        alert("ClientId copiado com sucesso!");
    };

    const handleCopyClientSecret = () => {
        navigator.clipboard.writeText(credentials.clientSecret);
        alert("ClientSecret copiado com sucesso!");
    };
    return (
        <div className="absolute md:w-[400px] z-50 right-[15%] top-0 md:right-[35%] bg-[#1D1D1D] rounded-[12px] p-4">
            <div className="w-full flex justify-between">
                <h1>Copie suas credenciais</h1>
                <svg onClick={() => { setModalOpen(false) }} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.7017 10.8615C11.7568 10.9167 11.8006 10.9822 11.8304 11.0542C11.8603 11.1263 11.8757 11.2036 11.8757 11.2816C11.8757 11.3596 11.8603 11.4368 11.8304 11.5089C11.8006 11.581 11.7568 11.6465 11.7017 11.7017C11.6465 11.7568 11.581 11.8006 11.5089 11.8304C11.4368 11.8603 11.3596 11.8757 11.2816 11.8757C11.2036 11.8757 11.1263 11.8603 11.0542 11.8304C10.9822 11.8006 10.9167 11.7568 10.8615 11.7017L5.93783 6.77724L1.01416 11.7017C0.902747 11.8131 0.75164 11.8757 0.59408 11.8757C0.43652 11.8757 0.285414 11.8131 0.174002 11.7017C0.0625904 11.5902 3.10588e-09 11.4391 0 11.2816C-3.10588e-09 11.124 0.0625904 10.9729 0.174002 10.8615L5.09842 5.93783L0.174002 1.01416C0.0625904 0.902747 0 0.75164 0 0.59408C0 0.43652 0.0625904 0.285414 0.174002 0.174002C0.285414 0.0625904 0.43652 0 0.59408 0C0.75164 0 0.902747 0.0625904 1.01416 0.174002L5.93783 5.09842L10.8615 0.174002C10.9729 0.0625904 11.124 -3.10588e-09 11.2816 0C11.4391 3.10588e-09 11.5902 0.0625904 11.7017 0.174002C11.8131 0.285414 11.8757 0.43652 11.8757 0.59408C11.8757 0.75164 11.8131 0.902747 11.7017 1.01416L6.77724 5.93783L11.7017 10.8615Z" fill="white" />
                </svg>

            </div>
            <p className="text-[#F53D3D] text-[12px]">Atenção sua secret só aparecera dessavez !</p>
            <div className="w-full mt-4 border-b border-[#343B4F] pb-2 flex justify-between">
                ClientId
                <div onClick={handleCopyClientId} className="p-1 px-2 bg-[#478DF8] cursor-pointer rounded-[10px] text-[12px]">Copiar</div>
            </div>
            <div className="w-full mt-2 border-b border-[#343B4F] pb-2  flex justify-between">
                Secret
                <div onClick={handleCopyClientSecret} className="p-1 px-2 bg-[#478DF8] cursor-pointer rounded-[10px] text-[12px]">Copiar</div>
            </div>
        </div>
    )
}

export default CredencialsModal